export default "/institutions/original.svg";